<template>
  <Popup :ref="(el) => popup = el"
         :hide-title="true"
         @onClose="hide"
  >
    <form>
      <div class="popup__content">
        <div class="alert mb-sm">
          <FormInputWrapper v-slot="parentProps" field="isAgreeBlacklistPaymentMethod" form="agreement">
            <div class=""  :class="parentProps.class">
              <input class="form-check-input" v-model="form.isAgreeBlacklistPaymentMethod" type="checkbox" value="" id="blacklistAgreement">
              <label class="form-check-label" for="blacklistAgreement">
                {{ helper.trans('labels.agree_with_risk')}}
              </label>
            </div>
          </FormInputWrapper>
        </div>

      </div>
      <div class="popup__controls">
        <button type="button" @click="hide" class="btn popup__close">
          <span class="text-capitalize-first">{{ $t('button.cancel') }}</span>
        </button>
        <LoaderButton :on-click="onOkClick" class="btn btn--accept">
          <span class="text-capitalize-first">{{ helper.trans('button.ok') }}</span>
        </LoaderButton>
      </div>
    </form>
  </Popup>
</template>
<script lang="ts">
import {computed, defineComponent, ref} from 'vue'
import {reactive, toRefs} from '@vue/reactivity';
import Popup from "@/apps/public/components/Popup.vue";
import {$t, helper} from "@/service/CommonHelper";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import TraderRequisitesDTO from "@/models/TraderRequisitesDTO";
import {api} from "@/service/APIClient";

export default defineComponent({
  methods: {$t},
  emits: ['state:updated', 'bulk:updated'],
  components: {LoaderButton, FormInputWrapper, Popup},
  setup(props, {emit}) {

    const state = reactive({
      form: {
        isAgreeBlacklistPaymentMethod: false
      } as any,
      item: null as TraderRequisitesDTO|null,
      items: [] as TraderRequisitesDTO[]
    });

    const onBulkOkClick = async () => {
      helper.clearErrors('agreement')
      try {
        const response = await api.bulkToggleRequisites('enable', state.items.map(item => item.id), state.form.isAgreeBlacklistPaymentMethod)
        emit('bulk:updated', response)
      } catch (e) {
        helper.handleErrors('agreement', e)
        return;
      }

      hide()
    }

    const onOkClick = async () => {
      if (state.items.length > 0) {
        await onBulkOkClick()

        return;
      }

      if (!state.item) {
        return;
      }

      helper.clearErrors('agreement')
      try {
        const req = await api.toggleRequisitesActivity(state.item.id, 'enable', state.form)
        state.item.isActive = req.isActive;
        emit('state:updated', {id: state.item.id, isActive: state.item.isActive})
      } catch (e) {
        helper.handleErrors('agreement', e)
        state.item.isActive = false;
        emit('state:updated', {id: state.item.id, isActive: state.item.isActive})
        return;
      } finally {
      }

      hide()
    }

    const popup = ref<InstanceType<typeof Popup> | null>(null)

    const show = (item: TraderRequisitesDTO|null) => {
      popup.value?.show()
      helper.clearErrors('agreement')
      state.form = {
        isAgreeBlacklistPaymentMethod: false
      }
      state.item = item
      state.items = []
    }

    const showForItems = (items: TraderRequisitesDTO[]) => {
      popup.value?.show()
      helper.clearErrors('agreement')
      state.form = {
        isAgreeBlacklistPaymentMethod: false
      }
      state.item = null
      state.items = items
    }

    const hide = () => {
      state.item = null
      state.items = []
      state.form = {
        isAgreeBlacklistPaymentMethod: false
      }
      popup.value?.hide()
    }

    return {
      ...toRefs(state),
      onOkClick,
      popup,
      helper,
      show,
      showForItems,
      hide,
    }
  }
})
</script>
